import {SENDMAIL, SENDMULTIPLEMAILS} from '../constants/actionTypes';

export default (mailsent = [], action) =>{
    switch (action.type){
        case SENDMAIL:
            return [... mailsent, action.payload];      
        case SENDMULTIPLEMAILS:
            return [mailsent[0], ...action.payload]
        default:
            return mailsent;      
    }
}